import React from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./navbar";         
import AuthNavbar from "./AuthNavbar"; // ✅ correct component
import "../../pages/task1.css";
import { useWakeLock } from "../../hooks/useWakeLock";

type LayoutProps = {
  children: React.ReactNode;
};

// All routes that should use the simple black auth header
const AUTH_PATHS = ["/", "/login", "/forgot-password", "/set-password", "/payment-success", "/payment-canceled", "/verify-email"];

const Layout: React.FC<LayoutProps> = ({ children }) => {
  useWakeLock();

  const location = useLocation();
  const isAuthPage = AUTH_PATHS.includes(location.pathname);

  return (
    <div className="flex flex-col min-h-screen bg-white justify-center">
      {/* Header */}
      {isAuthPage ? <AuthNavbar /> : <Navbar />}

      {/* Page content */}
      <main
        className={`flex items-center justify-center bg-white ${
          isAuthPage ? "pt-[124px]" : "pt-16"
        }`}
      >
        {children}
      </main>
    </div>
  );
};

export default Layout;
